import { BadgeResponseBuilder } from './BadgeResponseBuilder';
import { IBaseArgument } from './IBaseArgument';
import { BaseResponseBuilder } from './BaseResponseBuilder';

export class BadgesResponseBuilder extends BaseResponseBuilder {
    constructor() {
        super('Badges');
    }
    public withActivityHighlights = (builder: BadgeResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['activityHighlights'] = this.initField(builder, args);
        return this;
    }

    public withDeals = (builder: BadgeResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['deals'] = this.initField(builder, args);
        return this;
    }

    public withBookingInfo = (builder: BadgeResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['bookingInfo'] = this.initField(builder, args);
        return this;
    }

    public withPromocodes = (builder: BadgeResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['promocodes'] = this.initField(builder, args);
        return this;
    }

    public withKeyAttributes = (builder: BadgeResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['keyAttributes'] = this.initField(builder, args);
        return this;
    }
}
